import { POOL } from "../../pool";
import axiom from "../../utils/axiom";

export const createApiFromUrl = (details) =>
  axiom.post(POOL.base + POOL.paths.createShortUrl, details);
